app.component("snomedConceptTooltip", {
    templateUrl: "app/src/js/components/extractedSnomedConcept/snomed-concept-tooltip.html",
    bindings: {
        targetText: "@",
        concepts: "@"
    },
    controller: ['$element', function ($element) {
        var self = this;
        self.showMenu = false;
        self.tooltipStyle = {};
        self.conceptList = [];

        // Both attributes arrive URI-encoded (see snomedConceptUtil), so note text can never carry
        // markup or {{ }} into the compiled attribute.
        function decode(value) {
            try {
                return decodeURIComponent(value || '');
            } catch (e) {
                return value || '';
            }
        }

        self.$onChanges = function (changes) {
            if (changes.targetText) {
                self.displayText = decode(self.targetText);
            }
            if (changes.concepts) {
                try {
                    self.conceptList = JSON.parse(decode(self.concepts) || '[]');
                } catch (e) {
                    self.conceptList = [];
                }
            }
        };

        self.toggleMenu = function (show, event) {
            self.showMenu = show;

            if (show) {
                // Get the position of the highlighted text relative to the viewport
                var rect = $element[0].getBoundingClientRect();

                self.tooltipStyle = {
                    'position': 'fixed',
                    'top': (rect.top - 10) + 'px', // 10px gap above the text
                    'left': (rect.left + (rect.width / 2)) + 'px', // Center horizontally
                    'transform': 'translate(-50%, -100%)', // Pull it up and center it
                    'display': 'block',
                    'z-index': '9999'
                };
            }
        };
    }]
});
